export default __webpack_public_path__ + "static/media/P30005.67174526.png";